module.exports = __webpack_public_path__ + "img/map-blue.dc99a118.svg";